import { Box, Flex, IconButton, Spinner, Text } from '@chakra-ui/react'
import React from 'react'
import { FiMessageSquare, FiPlus, FiTrash2 } from 'react-icons/fi'
import { Conversation } from '../useConversations'

interface ConversationListProps {
  conversations: Conversation[]
  activeId: string | null
  isLoading: boolean
  onSelect: (id: string) => void
  onDelete: (id: string) => void
  onCreate: () => void
}

const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  activeId,
  isLoading,
  onSelect,
  onDelete,
  onCreate
}) => {
  return (
    <Box>
      <Flex
        px={3}
        py={2}
        justify="space-between"
        align="center"
        borderBottom="1px solid"
        borderColor="gray.200"
      >
        <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase">
          Conversations
        </Text>
        <IconButton
          aria-label="New conversation"
          icon={<FiPlus />}
          size="xs"
          variant="ghost"
          colorScheme="brand"
          onClick={onCreate}
        />
      </Flex>

      <Box overflowY="auto" maxH="200px">
        {isLoading ? (
          <Flex justify="center" py={4}>
            <Spinner size="sm" color="brand.500" />
          </Flex>
        ) : conversations.length === 0 ? (
          <Text fontSize="xs" color="gray.400" textAlign="center" py={4}>
            No conversations yet
          </Text>
        ) : (
          conversations.map((convo) => (
            <Flex
              key={convo.id}
              px={3}
              py={2}
              cursor="pointer"
              bg={convo.id === activeId ? 'brand.50' : 'transparent'}
              _hover={{ bg: convo.id === activeId ? 'brand.50' : 'gray.50' }}
              align="center"
              justify="space-between"
              onClick={() => onSelect(convo.id)}
              borderBottom="1px solid"
              borderColor="gray.100"
            >
              <Flex align="center" gap={2} flex={1} minW={0}>
                <Box flexShrink={0}>
                  <FiMessageSquare
                    size={12}
                    color={convo.id === activeId ? '#3EB489' : '#A0AEC0'}
                  />
                </Box>
                <Text
                  fontSize="xs"
                  color={convo.id === activeId ? 'brand.600' : 'gray.600'}
                  fontWeight={convo.id === activeId ? 'semibold' : 'normal'}
                  isTruncated
                >
                  {convo.title}
                </Text>
              </Flex>
              <IconButton
                aria-label="Delete conversation"
                icon={<FiTrash2 />}
                size="xs"
                variant="ghost"
                color="gray.400"
                _hover={{ color: 'red.500' }}
                onClick={(e) => {
                  e.stopPropagation()
                  onDelete(convo.id)
                }}
              />
            </Flex>
          ))
        )}
      </Box>
    </Box>
  )
}

export default ConversationList
